<template>
    <header class="bg-[#18181B]">
        <nav class="mx-auto flex max-w-7xl items-center justify-between p-6 lg:px-8" aria-label="Global">
            <div class="flex lg:flex-1">
                <RouterLink to="/" class="-m-1.5 p-1.5">
                    <img class="h-8 w-auto" :src="logoInkor" alt="Inkor" />
                </RouterLink>
            </div>
            <div class="flex lg:hidden">
                <button type="button" class="-m-2.5 inline-flex items-center justify-center rounded-md p-2.5 text-white"
                    @click="mobileMenuOpen = true">
                    <Bars3Icon class="size-6" aria-hidden="true" />
                </button>
            </div>

            <PopoverGroup class="hidden lg:flex lg:gap-x-8 lg:items-center">
                <RouterLink to="/sobre-nos" class="text-sm font-semibold text-white">Sobre Nós</RouterLink>
                <RouterLink to="/blog" class="text-sm font-semibold text-white">Blog</RouterLink>

                <!-- Produtos Dropdown -->
                <Popover class="relative">
                    <PopoverButton class="flex items-center gap-x-1 text-sm font-semibold text-white cursor-pointer">
                        Produtos
                        <ChevronDownIcon class="size-5 flex-none text-gray-400" aria-hidden="true" />
                    </PopoverButton>

                    <transition enter-active-class="transition ease-out duration-200"
                        enter-from-class="opacity-0 translate-y-1" enter-to-class="opacity-100 translate-y-0"
                        leave-active-class="transition ease-in duration-150"
                        leave-from-class="opacity-100 translate-y-0" leave-to-class="opacity-0 translate-y-1">
                        <PopoverPanel
                            class="absolute -left-8 top-full z-30 mt-3 w-screen max-w-xs overflow-hidden rounded-xl bg-white shadow-lg ring-1 ring-gray-900/5">
                            <div class="p-4">
                                <div v-for="cat in categorias" :key="cat.id" @click="irParaCategoria(cat.slug)"
                                    class="cursor-pointer group relative flex gap-x-6 rounded-lg p-2 text-sm hover:bg-gray-50">
                                    <div class="flex-auto">
                                        <span class="block font-semibold text-gray-900">{{ cat.nome }}</span>
                                    </div>
                                </div>
                            </div>
                            <div class="grid grid-cols-2 divide-x divide-gray-900/5 bg-gray-50">
                                <a v-for="item in callsToAction" :key="item.name" :href="item.href"
                                    class="flex items-center justify-center gap-x-2.5 p-3 text-sm font-semibold text-gray-900 hover:bg-gray-100">
                                    <component :is="item.icon" class="size-5 flex-none text-gray-400"
                                        aria-hidden="true" />
                                    {{ item.name }}
                                </a>
                            </div>
                        </PopoverPanel>
                    </transition>
                </Popover>
                <a href="/vagas" class="text-sm font-semibold text-white">Trabalhe Conosco</a>
                <a href="/downloads" class="text-sm font-semibold text-white">Downloads</a>
                <a href="/contato" class="text-sm bg-vermelho hover:bg-vermelho text-white gap-1 px-4 py-1.5 rounded-lg font-semibold text-white">
                    <!-- <Headset class="h-4 w-4 inline-block" /> -->
                    Entre em Contato</a>
            </PopoverGroup>

            <!-- <div class="hidden lg:flex lg:flex-1 lg:justify-end">
                <a href="#" class="text-sm font-semibold text-white">Painel Inkor <span
                        aria-hidden="true">&rarr;</span></a>
            </div> -->
        </nav>

        <!-- Mobile Menu -->
        <Dialog class="lg:hidden" @close="mobileMenuOpen = false" :open="mobileMenuOpen">
            <div class="fixed inset-0 z-10" />
            <DialogPanel
                class="fixed inset-y-0 right-0 z-10 w-full flex flex-col justify-between overflow-y-auto bg-white sm:max-w-sm sm:ring-1 sm:ring-gray-900/10">
                <div class="p-6">
                    <div class="flex items-center justify-between">
                        <RouterLink to="/"
                            class="flex items-center gap-2 block rounded-lg px-3 py-2 text-base font-semibold text-gray-900 hover:bg-gray-50">
                            <HouseIcon class="h-4 w-4" />
                            Início
                        </RouterLink>
                        <button type="button" class="-m-2.5 rounded-md p-2.5 text-gray-700"
                            @click="mobileMenuOpen = false">
                            <XMarkIcon class="size-6" aria-hidden="true" />
                        </button>
                    </div>

                    <div class="mt-6 flow-root">
                        <div class="-my-6 divide-y divide-gray-500/10">
                            <div class="space-y-2 py-6">
                                <RouterLink to="/sobre-nos"
                                    class="block rounded-lg px-3 py-2 text-base font-semibold text-gray-900 hover:bg-gray-50">
                                    Sobre Nós
                                </RouterLink>
                                <hr class="text-gray-300" />
                                <div v-for="cat in categorias" :key="cat.id" @click="handleMobileRedirect(cat.slug)"
                                    class="block rounded-lg px-3 py-2 text-base font-semibold text-gray-900 hover:bg-gray-50 cursor-pointer">
                                    {{ cat.nome }}
                                </div>
                                <hr class="text-gray-300" />
                                <a href="#"
                                    class="block rounded-lg px-3 py-2 text-base font-semibold text-gray-900 hover:bg-gray-50">Entre em Contato</a>
                                <a href="/vagas"
                                    class="block rounded-lg px-3 py-2 text-base font-semibold text-gray-900 hover:bg-gray-50">Trabalhe
                                    Conosco</a>
                                <a href="/downloads"
                                    class="block rounded-lg px-3 py-2 text-base font-semibold text-gray-900 hover:bg-gray-50">Downloads</a>
                            </div>
                        </div>
                    </div>
                </div>
            </DialogPanel>
        </Dialog>
    </header>
</template>

<script setup>
import { ref, onMounted } from "vue";
import { useRouter } from "vue-router";
import axios from "axios";
import logoInkor from "../assets/img/inkor-logo.png";
import {
    Dialog,
    DialogPanel,
    Popover,
    PopoverButton,
    PopoverGroup,
    PopoverPanel,
} from "@headlessui/vue";
import {
    ChevronDownIcon,
    PhoneIcon,
    PlayCircleIcon,
} from "@heroicons/vue/20/solid";
import { Bars3Icon, XMarkIcon } from "@heroicons/vue/24/outline";
import { Headset, HouseIcon } from "lucide-vue-next";

const router = useRouter();
const categorias = ref([]);
const mobileMenuOpen = ref(false);

// const callsToAction = [
//     { name: "Institucional", href: "#", icon: PlayCircleIcon },
//     { name: "Entre em Contato", href: "/contato", icon: PhoneIcon },
// ];

const irParaCategoria = (slug) => {
    router.push({
        name: "produtos-categoria",
        params: { categoriaSlug: slug },
    });
};

const handleMobileRedirect = (slug) => {
    mobileMenuOpen.value = false;
    irParaCategoria(slug);
};

onMounted(async () => {
    const { data } = await axios.get("/api/categorias");
    categorias.value = data;
});
</script>

<style scoped>
.cursor-pointer {
    cursor: pointer;
}
</style>
